var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUploadFileGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 30,
    viewBox: "0 0 44 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D3DBDF",
    d: "M36.761 12.845C35.768 5.465 29.523 0 22 0 15.542 0 9.935 4.045 7.877 10.148 3.265 11.142 0 15.116 0 19.871c0 5.18 4.045 9.51 9.226 9.935h27.038C40.595 29.381 44 25.69 44 21.29c0-4.187-3.123-7.806-7.239-8.445zm-7.167 3.974c-.142.142-.284.213-.497.213-.213 0-.355-.07-.497-.213l-5.89-5.89v13.91c0 .426-.284.71-.71.71s-.71-.284-.71-.71v-13.91l-5.89 5.89c-.284.284-.71.284-.994 0-.283-.284-.283-.71 0-.993l7.097-7.097c.071-.07.142-.142.213-.142.142-.07.355-.07.568 0 .07.071.142.071.213.142l7.097 7.097c.283.284.283.71 0 .993z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploadFileGrey);
export default __webpack_public_path__ + "static/media/cloud-upload-file-grey.450d46a607e7c489982ae1053ff470d5.svg";
export { ForwardRef as ReactComponent };